import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import authBg from "../../assets/images/big/auth-bg.jpg";
import Swal from "sweetalert2"; // Ensure you have Swal for alerts
import { verifymail } from "../../store/slices/userSlice"; // Make sure to use your correct slice path
import logo from "../../assets/images/logo.png";

import { Link } from "react-router-dom";
const Emailverified = () => {
  const location = useLocation(); // Get the location to access query parameters
  const [isVerified, setIsVerified] = useState(false); // Track if the email was verified

  // Get the query parameters (like the encrypted verification ID)
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const encryptedId = queryParams.get("token"); // Get 'id' from the URL query string

    if (encryptedId) {
      handleVerification(encryptedId); // Call the verification function with the encrypted ID
    }
  }, [location.search]); // Run when location/search changes

  const handleVerification = async (encryptedId) => {
    try {
      // Pass the encrypted ID to your backend for decryption and verification
      const response = await verifymail(encryptedId);

      if (response?.status === 200) {
        setIsVerified(true);
        Swal.fire("Success", "Your email has been verified successfully!", "success");
      } else {
        Swal.fire("Error", "Error verifying the email!", "error");
      }
    } catch (error) {
      console.error("Error verifying email:", error);
      Swal.fire("Error", "Something went wrong while verifying your email!", "error");
    }
  };

  return (
    <div className="main-wrapper">

      <div
        className="auth-wrapper d-flex no-block justify-content-center align-items-center position-relative"
        style={{ background: `url(${authBg}) no-repeat center center` }}
      >
        <div className="auth-box row d-flex no-block justify-content-center align-items-center ">
          <div className="col-lg-8 col-md-12 bg-white">
            <div className="p-3">
              <div className="text-center">
                <img src={logo} width="100%" alt="Logo" />
              </div>
              <div className="text-center">
                <h2 className="mt-3 text-center">
                  {isVerified ? "Email Verified" : "Verifying Your Email"}
                </h2>
              </div>
              {isVerified ? (
                <div className="text-center">
                  <p>Your email has been successfully verified. You can now log in.</p>
                  <Link to="/login" className="btn btn-dark">Go to Login</Link>
                </div>
              ) : (
                <div className="text-center">
                  <p>Please wait while we verify your email...</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Emailverified;
